<template>
  <div>
    <div
      class="custom-list codelos-custom-list font-aktiv-grotesk"
      v-if="showLinkedTable"
    >
      <div class="h-100">
        <div
          class="group-actions"
          v-show="
            showGroupAction &&
            !htmlViewerModal.isHtmlViewerVisible &&
            !isLoading
          "
        >
          <div class="inner">
            <p>
              <span class="selected-items">{{ selectedItemCount }}</span>
              <span class="selected-items-label">Ausgewählte Einträge</span>
            </p>
            <ul class="toolbar">
              <li
                class="item share"
                @click="shareSelectedItems()"
                v-show="isItemSelected"
                v-b-tooltip
                title="Teilen"
              >
                <a class="link">share</a>
              </li>

              <li
                class="item download"
                @click="exportSelectedItems()"
                v-show="isItemSelected"
                v-b-tooltip.hover
                title="Herunterladen"
              >
                <a class="link">download</a>
              </li>
              <li
                v-if="database.access_level !== 'read' && !database.add_only"
                class="item delete"
                @click="deleteSelectedItems()"
                v-b-tooltip.hover
                title="Löschen"
              >
                <a class="link">delete</a>
              </li>
            </ul>
          </div>
          <div
            v-show="filteredItems.length > 1 && !isAddOptionsVisible"
            class="select-all-wrapper"
          >
            <button
              class="btn-select-all"
              :disabled="allItemsSelected"
              @click="selectAll()"
            >
              Alle auswählen
            </button>
            <button class="btn-select-all" @click.prevent="unSelectAll()">
              Alle abwählen
            </button>
          </div>
        </div>
        <CustomDatabaseListView
          ref="customDatabaseListRef"
          :filters="[]"
          :items="filteredItems"
          :headersList="headersList"
          :database="database"
          :pagination="pagination"
          :filteredItems="filteredItems"
          :displayParam="displayParam"
          :getSqlKey="getSqlKey"
          :isSelectedItem="isSelectedItem"
          :isDatabaseDropDownLoading="isDatabaseDropDownLoading"
          :inlineView="true"
          :dropdownApiLoading="dropdownApiLoading"
          :headerNameLableObject="linkedViewHeaderNameLabelObject"
          @setCustomHighlightedItems="setCustomHighlightedItems"
          @checkSelectedItemOnClick="checkSelectedItemOnClick"
          @onTimeTriggerEditItem="onTimeTriggerEditItem"
          @shareItem="shareItem"
          @duplicateItem="duplicateItem"
          @exportItem="exportItem"
          @deleteItem="deleteItem"
          @runAction="runAction"
          @createNewAction="createNewAction"
          @appendRows="appendRows"
        />
        <modal-share
          class="modal-window"
          v-if="shareSetting.isShareModalVisible"
          :artefact="this.shareSetting.artefact"
          :description="this.shareSetting.description"
          :attachment="this.shareSetting.attachment"
          @close="closeModal"
        />
        <htmlViewer
          v-if="htmlViewerModal.isHtmlViewerVisible"
          @close="closeHtmlViewer"
          :myHtml="htmlViewerModal.myHtml"
        >
        </htmlViewer>
        <removeConfirmationModal
          v-if="confirmationModal.isVisible"
          class="modal-window"
          :id="confirmationModal.id"
          :name="confirmationModal.name"
          :resourceType="confirmationModal.resourceType"
          :actionType="confirmationModal.actionType"
          :itemsCount="confirmationModal.itemsCount"
          :selectedItems="deleteConfirmationRecords"
          :databaseName="database.name"
          @close="closeConfirmationModal"
          @confirmRemove="confirmRemoveItem"
        />
      </div>
    </div>
    <TableSkeleton v-else :isLoading="tableSkeletonLoader"></TableSkeleton>
  </div>
</template>

<script>
import CustomDatabaseListView from '../../components/CustomDatabase/CustomDatabaseListViewComponent.vue';
import {
  debouncer,
  isObjectType,
  getFlowLastId,
  jsonParser,
} from '../../utils/helpers';
import { runFlowByID } from '../../services/axios/flow-runner.api';
import ModalShare from '../../components/modals/ModalShare.vue';
import { getCustomDatabaseItems } from '../../services/customdb.service';
import TableSkeleton from '../../components/widgets/TableSkeleton.vue';
import htmlViewer from '../../components/modals/htmlViewer.vue';

import { mapActions, mapGetters } from 'vuex';
import Store from '../../store/store';
import { getDataBaseTableSchema } from '../../services/userTable';
import removeConfirmationModal from '../../components/modals/removeConfirmModal.vue';

export default {
  name: 'CustomDatabaseInline',

  data() {
    return {
      tableSkeletonLoader: false,
      headersList: [],
      filteredItems: [],
      database: {},
      shareSetting: {
        isShareModalVisible: false,
        artefact: '',
        description: '',
        attachment: null,
      },
      htmlViewerModal: {
        isHtmlViewerVisible: false,
        myHtml: null,
      },
      isAddOptionsVisible: false,
      isLoading: false,
      customHighlightedItems: [],
      view: null,
      elOnHoverIdx: null,
      highlightItems: {},
      dataSchema: [],
      lastSelectedItemIdForShiftSelect: null,
      selectedItemIds: [],
      customData: [],
      allDatabaseLinkedItems: [],
      isActionDropDownLoading: {
        itemID: null,
        actionID: null,
      },
      itemToDelete: null,
      confirmationModal: {
        id: null,
        name: null,
        actionType: 'remove',
        isVisible: false,
        resourceType: 'item',
        isMultipleItems: false,
        itemsCount: 0,
      },
      manageTimeTriggerModal: {
        visible: false,
        mode: null,
        data: null,
      },
      isCopyDatabaseItem: false,
      pagination: {
        limit: 30,
        isEnabled: true,
        lastEvaluatedKey: '',
        isFetchingIems: false,
      },
      dropdownApiLoading: false,
      linkedViewHeaderNameLabelObject: null,
    };
  },
  props: {
    element: {
      type: Object,
      required: true,
    },
    elements: {
      type: Array,
      required: true,
    },
    isAddingNewItem: {
      type: Boolean,
      default: false,
    },
    isDatabaseLinkedViewinAdd: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    ...mapActions(['checkTokenRefresh']),
    selectAll() {
      this.selectedItemIds = this.filteredItems.map(
        (item) => item[this.getSqlKey('id')]
      );
    },
    unSelectAll() {
      this.selectedItemIds = [];
    },
    deleteSelectedItems() {
      if (
        !this.database.hasOwnProperty('confirmDelete') ||
        this.database.confirmDelete === null ||
        JSON.parse(this.database.confirmDelete)
      )
        this.confirmationModal = {
          ...this.confirmationModal,
          name: 'Alle löschen',
          isVisible: true,
          isMultipleItems: true,
          itemsCount: this.selectedItemCount,
        };
      else this.removeSelectedItems();
    },
    removeSelectedItems: function () {
      var url = process.env.VUE_APP_DATA_API + '/user-tables/';
      url += this.tableName + '/items';

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('content-type', 'application/json');

      let ids = this.selectedItems.map((e) => e[this.getSqlKey('id')]);

      this.selectedItems.map((e) => (e.loading = true));

      let payload = {
        id: ids,
      };

      fetch(url, {
        body: JSON.stringify(payload),
        headers: myHeaders,
        method: 'DELETE',
      })
        .then((response) => {
          if (response.status == 401) this.handleTokenExpired();
          else return response.json();
        })
        .then(() => {
          this.selectedItems.map((e) => (e.loading = false));
          this.filteredItems = this.filteredItems.filter((x) => {
            return !ids.includes(x[this.getSqlKey('id')]);
          });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    async exportSelectedItems() {
      this.isLoading = true;
      this.selectedItems.map((e) => (e.loading = true));
      const content = await this.objectsToCSV(this.selectedItems);
      this.download(content);
      this.isLoading = false;
      this.selectedItems.map((e) => (e.loading = false));
    },
    shareSelectedItems: async function () {
      this.shareSetting.artefact = 'Datenbankeinträge';
      this.shareSetting.description =
        'Der Empfänger wird eine E-Mail mit den Datenbankeinträgen als Anhang empfangen.';
      this.shareSetting.attachment = await this.getItemAsBlob(
        this.selectedItems
      );
      this.shareSetting.isShareModalVisible = true;
    },
    closeModal: function () {
      this.shareSetting.isShareModalVisible = false;
    },
    isDatabaseDropDownLoading(actionid, itemid) {
      return (
        this.isActionDropDownLoading.itemID !== null &&
        this.isActionDropDownLoading.actionID !== null &&
        this.isActionDropDownLoading.itemID == itemid &&
        this.isActionDropDownLoading.actionID == actionid
      );
    },
    isElementHasSettings(element) {
      return element.hasOwnProperty('settings');
    },
    getElementSettings(element, key) {
      if (this.isElementHasSettings(element)) {
        return element.settings.hasOwnProperty(key)
          ? element.settings[key]
          : null;
      } else {
        return element.hasOwnProperty(key) ? element[key] : null;
      }
    },
    displayParam(item) {
      // eslint-disable-next-line no-unused-vars
      // let { id, selected, ...displayItem } = item;
      const displayItem = JSON.parse(JSON.stringify(item));

      delete displayItem[this.getSqlKey('id')];
      delete displayItem.selected;
      let highlightItems = this.getHighlightedItems(displayItem);
      //TODO: Move this part to higlighted items function
      // Return all if nothing is highlighted

      if (Object.keys(highlightItems).length < 1) {
        const keysToRemove = [
          this.getSqlKey('id'),
          this.getSqlKey('owner'),
          this.getSqlKey('created'),
          this.getSqlKey('updated'),
          'selected',
          'loading',
        ];

        // Get layoutitems
        let layoutItems = this.database.schema
          ? JSON.parse(this.database.schema)
          : []
              .filter((e) => this.getElementSettings(e, 'layoutItem') === true)
              .map((e) => e.name);
        let copyItem = JSON.parse(JSON.stringify(displayItem));

        // Remove frontend & layout keys
        for (let k of keysToRemove.concat(layoutItems)) {
          delete copyItem[k];
        }
        copyItem = Object.fromEntries(Object.entries(copyItem).slice(0, 5));
        return copyItem;
      }
      return highlightItems;
    },
    getHighlightedItems(items) {
      const tempHighlightItems = { ...this.highlightItems };
      if (this.isCustomHighlighting) {
        Object.keys(items).forEach((el) => {
          let i = this.customHighlightedItems.find((e) => e.name == el);
          if (i != undefined && i.selected == true) {
            this.highlightItems[el] = '';
            if (this.isCorrectElementType(el, 'freecontent')) {
              tempHighlightItems[el] = items[el];
            } else {
              tempHighlightItems[el] = isObjectType(items[el])
                ? items[el].name
                : items[el];
            }
          }
          //   let totalKeys = Object.keys(items);
          // for (let i = 0; i < totalKeys.length; i++) {
          //   let item = this.customHighlightedItems.find(
          //     e => e.name == totalKeys[i]
          //   );
          //   if (
          //     item !== undefined &&
          //     JSON.parse(JSON.stringify(item)).selected === true
          //   ) {
          //     highlightItems[totalKeys[i]] = items[totalKeys[i]];
        });
      } else {
        Object.keys(items).forEach((el) => {
          let i = this.dataSchema.find((e) => e.name == el);
          if (
            i != undefined &&
            this.getElementSettings(i, 'highlight') == true
          ) {
            if (this.isCorrectElementType(el, 'freecontent')) {
              tempHighlightItems[el] = items[el];
            } else {
              tempHighlightItems[el] = isObjectType(items[el])
                ? items[el].name
                : items[el];
            }
          }
        });
      }

      return this.sortItemsAsSchemaOrder(tempHighlightItems);
    },
    sortItemsAsSchemaOrder(items) {
      // Order items
      let itemOrder = this.dataSchema.map((e) => e.name);

      return itemOrder.reduce((sorted, key) => {
        if (items.hasOwnProperty(key)) {
          sorted[key] = items[key];
        }
        return sorted;
      }, {});
      // return JSON.parse(JSON.stringify(items, itemOrder));
    },
    isCorrectElementType(header, elementType) {
      const { isCorrectType } = this.getObjectData(header, elementType);
      return isCorrectType;
    },
    getObjectData(header, elementType) {
      if (this.database.schema) {
        const dataObject = JSON.parse(this.database.schema).find(
          (el) => el.name.trim() === header.trim()
        );
        const elementTypesToMatch =
          elementType === 'radio' ? ['radio', 'status'] : [elementType];
        if (
          dataObject &&
          dataObject.type &&
          elementTypesToMatch.includes(dataObject.type)
        ) {
          return { isCorrectType: true, data: dataObject };
        }
      }
      return { isCorrectType: false, data: {} };
    },
    setCustomHighlightedItems(headerArr) {
      if (headerArr) this.headersList = headerArr;
      if (
        this.userSettings &&
        this.userSettings.customDatabaseSchema &&
        this.userSettings.customDatabaseSchema[this.database.name] !==
          undefined &&
        this.userSettings.customDatabaseSchema[this.database.name]
          .colPosition !== undefined &&
        this.userSettings.customDatabaseSchema[this.database.name].colPosition
          .length !== 0
      ) {
        const header =
          headerArr && headerArr.length > 0
            ? headerArr
            : this.userSettings.customDatabaseSchema[this.database.name]
                .colPosition;

        const data = [...this.customHighlightedItems].sort((a, b) => {
          const indexA = header.indexOf(a.name);
          const indexB = header.indexOf(b.name);

          if (indexA === indexB) return 0;
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;

          return indexA - indexB;
        });

        const finaldata = [...data].map((ele) => {
          if (header.includes(ele.name)) {
            return { ...ele, selected: true };
          } else {
            return { ...ele, selected: false };
          }
        });

        this.customData = finaldata;
      } else {
        this.customData = this.customHighlightedItems;
      }
    },
    checkSelectedItemOnClick(event, item) {
      const currentItemSelectedIndex = this.filteredItems.findIndex(
        (itemDetails) => {
          return (
            itemDetails[this.getSqlKey('id')] ==
              this.lastSelectedItemIdForShiftSelect &&
            this.isSelectedItem(itemDetails[this.getSqlKey('id')])
          );
        }
      );
      if (
        event.shiftKey &&
        currentItemSelectedIndex != -1 &&
        !this.isSelectedItem(item[this.getSqlKey('id')])
      ) {
        this.selectAllItemsBetweenShiftPressed(currentItemSelectedIndex, item);
      } else {
        this.toggleSeletedItem(item[this.getSqlKey('id')]);

        this.lastSelectedItemIdForShiftSelect = item[this.getSqlKey('id')];
      }
      this.$forceUpdate();
    },
    selectAllItemsBetweenShiftPressed(currentItemSelectedIndex, item) {
      const newItemSelectionIndex = this.filteredItems.findIndex(
        (filteredItem) =>
          filteredItem[this.getSqlKey('id')] == item[this.getSqlKey('id')]
      );

      currentItemSelectedIndex < newItemSelectionIndex
        ? this.selectFilterItemsInCustomRange(
            currentItemSelectedIndex,
            newItemSelectionIndex
          )
        : this.selectFilterItemsInCustomRange(
            newItemSelectionIndex,
            currentItemSelectedIndex
          );
    },
    selectFilterItemsInCustomRange(startingIndex, endingIndex) {
      this.filteredItems.forEach((filteredItem, index) =>
        index >= startingIndex && index <= endingIndex
          ? this.selectItem(filteredItem[this.getSqlKey('id')])
          : ''
      );
    },
    toggleSeletedItem(id) {
      const index = this.selectedItemIds.findIndex(
        (selectedId) => selectedId == id
      );
      if (index > -1) {
        this.selectedItemIds.splice(index, 1);
      } else {
        this.selectedItemIds.push(id);
      }
    },
    async onTimeTriggerEditItem(item) {
      this.toggleTimeTriggerModal(true, 'edit', {
        databaseID: this.database.name,
        itemID: item.id,
      });
    },
    toggleTimeTriggerModal(visible, mode, data) {
      if (!visible) {
        this.toggleCopyDatabaseItem(false);
      }
      this.manageTimeTriggerModal = {
        visible: visible,
        mode: mode,
        data: data,
      };
    },
    toggleCopyDatabaseItem(bool) {
      this.isCopyDatabaseItem = bool;
    },
    shareItem: async function (i) {
      try {
        this.shareSetting.artefact = 'Datenbankeintrag';
        this.shareSetting.description =
          'Der Empfänger wird eine E-Mail mit dem Datenbankeintrag als Anhang empfangen.';
        this.shareSetting.attachment = await this.getItemAsBlob([i]);
        this.shareSetting.isShareModalVisible = true;
      } catch (error) {
        console.log(error);
      }
    },
    getItemAsBlob: async function (i) {
      const content = await this.objectsToCSV(i);
      let dataStr =
        'data:text/csv;charset=utf-8,' + encodeURIComponent(content);
      return fetch(dataStr)
        .then((res) => res.blob())
        .then((blob) => {
          return blob;
        });
    },
    objectsToCSV: async function (arr) {
      // Remove frontend keys
      let copy_arr = JSON.parse(JSON.stringify(arr));
      copy_arr.forEach((e) => {
        delete e.loading;
        delete e[this.getSqlKey('owner')];
        delete e[this.getSqlKey('created')];
        delete e[this.getSqlKey('updated')];
        delete e[this.getSqlKey('id')];
      });

      var colNames = Object.keys(copy_arr[0]);
      var colVals = copy_arr;

      // Translate keys to labels
      colNames.forEach((part, index) => {
        if (colNames[index] != this.getSqlKey('id'))
          colNames[index] = this.itemsAsObjects[colNames[index]];
      });

      // Create CSV-String from values
      let vals = colVals
        .map((row) => {
          return Object.values(row)
            .map((value) => {
              return typeof value === 'string' ? value : JSON.stringify(value);
            })
            .join(';');
        })
        .join('\n');

      // Create CSV-String from col names
      let cols = colNames.join(';') + '\n';

      return cols + vals;
    },
    duplicateItem(item) {
      this.toggleCopyDatabaseItem(true);
      if (this.database.type === 'timetrigger') {
        this.onTimeTriggerEditItem(item);
      } else {
        this.$router.push({
          name: 'home',
          params: {
            isCopyDatabase: 'true',
          },
          query: {
            section: 'data',
            database: this.database.name,
            item: item[this.getSqlKey('id')].toString(),
          },
        });
      }
    },
    async exportItem(i) {
      this.checkTokenRefresh();
      i.loading = true;
      const content = await this.objectsToCSV([i]);
      this.download(content);
      i.loading = false;
    },
    download: function (content) {
      let dataStr =
        'data:text/csv;charset=utf-8,' + encodeURIComponent(content);
      var link = document.createElement('a');
      link.setAttribute('href', dataStr);
      link.setAttribute(
        'download',
        this.nameWithoutPrefix(this.tableName) + '.csv'
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    nameWithoutPrefix: function (name) {
      return name.split('_').slice(1).join('_');
    },
    deleteItem(e) {
      if (
        !this.database.hasOwnProperty('confirmDelete') ||
        this.database.confirmDelete === null ||
        JSON.parse(this.database.confirmDelete)
      ) {
        this.confirmationModal = {
          ...this.confirmationModal,
          name: 'Eintrag löschen',
          isVisible: true,
          isMultipleItems: false,
        };
        this.itemToDelete = e;
      } else this.removeItem(e);
    },
    async removeItem(e) {
      const time = new Date().getTime();
      const dbItemLog = {
        author: this.user.attributes.sub,
        'time-start': time,
        'time-end': time,
        'context-parent-type': 'database',
        'context-parent-id': null,
        'context-type': 'database-item',
        'context-id': this.database.name,
        'activity-values': {
          'activity-type': 'database-entry-delete',
          edits: [
            {
              'item-id': e[this.getSqlKey('id')],
            },
          ],
        },
      };
      e.loading = true;

      const url = `${process.env.VUE_APP_DATA_API}/user-tables/${
        this.tableName
      }/items/${e[this.getSqlKey('id')]}`;

      const myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );
      myHeaders.append('content-type', 'application/json');
      try {
        this.dropdownApiLoading = true;
        const response = await fetch(url, {
          headers: myHeaders,
          method: 'DELETE',
        });

        if (response.status == 200) {
          this.filteredItems = this.filteredItems.filter((x) => {
            return x[this.getSqlKey('id')] != e[this.getSqlKey('id')];
          });
        } else if (response.status == 401) this.handleTokenExpired();
        else throw new Error(response.statusText);
        e.loading = false;
      } catch (err) {
        e.loading = false;
        throw new Error(err);
      } finally {
        this.dropdownApiLoading = false;
      }
    },
    getSqlKey(key) {
      if (this.database.sql_cdls && JSON.parse(this.database.sql_cdls)[key]) {
        return JSON.parse(this.database.sql_cdls)[key];
      } else return key;
    },
    runAction: function (id, hoverDataId = this.elOnHoverIdx) {
      this.isActionDropDownLoading = { actionID: id, itemID: hoverDataId };
      const params = `?id=${id}&modeldatabaseid=${this.database.name}&model=${
        hoverDataId ? hoverDataId : this.selectedItems[0][this.getSqlKey('id')]
      }`;
      this.runActionApi(params);
    },
    async runActionApi(params) {
      try {
        this.dropdownApiLoading = true;
        const response = await runFlowByID('', params);
        if (response && response.status === 200 && response.data) {
          this.$set(this.htmlViewerModal, 'myHtml', response.data);
          this.$set(this.htmlViewerModal, 'isHtmlViewerVisible', true);
          this.isActionDropDownLoading = { actionID: null, itemID: null };
          this.isLoading = false;
        }
      } catch (error) {
        let message;
        if (error && error.data && error.data.message) {
          message = error.data.message;
        } else {
          message = 'Fehler beim Ausführen des Flows';
        }
        this.showToaster(message, 'Fehlerhaft !', 'danger');
        this.isActionDropDownLoading = { actionID: null, itemID: null };
        this.$refs.customDatabaseListRef.$refs.customTableRef.hideDropDown();
        this.isLoading = false;
      } finally {
        this.dropdownApiLoading = false;
      }
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    newID() {
      return getFlowLastId(this);
    },
    createNewAction: async function (elOnHoverIdx = this.elOnHoverIdx) {
      let id = this.newID();
      let rslt = await this.$store.dispatch('createNewFlow', {
        id: id,
        type: 'action',
        dataType: 'custom',
        fileKey: elOnHoverIdx
          ? elOnHoverIdx
          : this.selectedItems[0][this.getSqlKey('id')],
        tableID: this.database.name,
      });

      if (rslt == 'Access Token has expired') {
        this.handleTokenExpired();
      } else {
        this.$router.push({
          path: '/',
          query: {
            section: 'process-designer',
            process: id,
          },
        });
      }
    },
    async getDatabaseLinkedViewData() {
      try {
        if (!this.isAddingNewItem) return;
        let params = '';
        if (this.databaseLinkedViewFetchColumns.length) {
          params = `?keys=${this.databaseLinkedViewFetchColumns}`;
        }
        const databaseData = await getCustomDatabaseItems(
          this.databaseLinkedViewRefactoredData.selectedDatabaseID,
          params
        );
        this.allDatabaseLinkedItems = Array.isArray(databaseData?.data?.items)
          ? databaseData.data.items
          : [];
        if (this.databaseLinkedViewSelectedColumns.length) {
          this.headersList = this.databaseLinkedViewSelectedColumns;
          const findDatabase = this.databaseList.find(
            (database) =>
              database.name ===
              this.element.settings.connectedDatabase.selectedDatabaseID
          );
          let schema;
          if (findDatabase.schema) {
            schema = JSON.parse(findDatabase.schema);
          } else {
            const response = await getDataBaseTableSchema(
              this.element.settings.connectedDatabase.selectedDatabaseID,
              true
            );
            if (response && response.status === 200 && response.data) {
              this.$store.commit('SET_DATABASE_SCHEMA', response.data);
            }
            schema = JSON.parse(findDatabase.schema);
          }
          let headerNameLabelObject = {};
          for (const item of schema) {
            if (
              this.databaseLinkedViewSelectedColumns.includes(item.name)
            ) {
              headerNameLabelObject[item.name] = item.label;
            }
          }
          this.linkedViewHeaderNameLabelObject = headerNameLabelObject;
        } else if (this.allDatabaseLinkedItems && this.allDatabaseLinkedItems.length) {
          const headerElements = Object?.keys?.(this.allDatabaseLinkedItems[0]);
          if (headerElements.length > 2) {
            const indexOfId = headerElements.indexOf('id');
            if (indexOfId !== -1) headerElements.splice(indexOfId, 1);
            const indexOfLoading = headerElements.indexOf('loading');
            if (indexOfLoading !== -1) headerElements.splice(indexOfLoading, 1);
          }
          this.headersList = headerElements;
        }
        this.applyLinkedViewFilter();
      } catch (error) {
        console.log('error :>> ', error);
        throw error;
      }
    },
    applyLinkedViewFilter() {
      const linkedElement = this.elements.find(
        (element) =>
          element.name ===
          this.databaseLinkedViewRefactoredData.currentTableFieldKey
      );
      const linkedValue = linkedElement?.value;

      if (
        linkedValue === null ||
        linkedValue === undefined ||
        linkedValue === ''
      ) {
        this.filteredItems = [];
        return;
      }

      const sourceItems = Array.isArray(this.allDatabaseLinkedItems)
        ? this.allDatabaseLinkedItems
        : [];

      if (!sourceItems.length) {
        this.filteredItems = [];
        return;
      }

      const firstProp = Object?.keys(sourceItems[0])[0];
      this.filteredItems = sourceItems
        .filter((item) => {
          const itemValue =
            item[this.databaseLinkedViewRefactoredData.currentTableFieldKey];
          return (
            this.normalizeLinkedValue(itemValue) ===
            this.normalizeLinkedValue(linkedValue)
          );
        })
        .map((item) => {
          const databaseItem = this.databaseLinkedViewSelectedColumns.length
            ? { ...item, loading: false }
            : {
                [this.databaseLinkedViewRefactoredData.currentTableFieldKey]:
                  item[this.databaseLinkedViewRefactoredData.currentTableFieldKey],
                id: item.id,
                loading: false,
              };

          if (firstProp && !databaseItem[firstProp]) {
            databaseItem[firstProp] = item[firstProp];
          }

          return databaseItem;
        });
    },
    normalizeLinkedValue(value) {
      return value === null || value === undefined
        ? ''
        : value.toString().trim().toLowerCase();
    },

    handleTokenExpired: function () {
      localStorage.clear(),
        this.$router.push({
          name: 'auth',
          params: { message: 'Sitzung abgelaufen' },
        });
    },
    isSelectedItem(id) {
      return this.selectedItemIds.includes(id);
    },
    appendRows() {},
    closeHtmlViewer() {
      this.$set(this.htmlViewerModal, 'isHtmlViewerVisible', false);
    },
    closeConfirmationModal() {
      this.confirmationModal = {
        ...this.confirmationModal,
        name: '',
        isVisible: false,
        isMultipleItems: false,
      };
      this.itemToDelete = null;
    },
    confirmRemoveItem() {
      this.confirmationModal.isMultipleItems
        ? this.removeSelectedItems()
        : this.removeItem(this.itemToDelete);
    },
  },
  computed: {
    ...mapGetters({
      databaseList: 'getDatabaseList',
      getsidebarLinkedCustomDBSettings: 'getsidebarLinkedCustomDBSettings',
    }),
    allItemsSelected() {
      let selectedItems = this.filteredItems.filter((i) =>
        this.isSelectedItem(i[this.getSqlKey('id')])
      ).length;
      return selectedItems == this.filteredItems.length;
    },
    isItemSelected() {
      return this.selectedItemCount > 0;
    },
    selectedItemCount() {
      return this.selectedItems.length;
    },
    showGroupAction() {
      return (
        this.filteredItems.filter((i) =>
          this.isSelectedItem(i[this.getSqlKey('id')])
        ).length > 0
      );
    },
    userSettings() {
      return this.$store.state.userSettings;
    },
    user() {
      return Store.state.user;
    },

    actionList() {
      return Store.state.flows
        .filter((e) => e.type == 'action' && e.table_id == this.database.name)
        .sort((a, b) =>
          (a?.name || '').localeCompare(b?.name || '', undefined, {
            sensitivity: 'base',
            numeric: true,
          })
        );
    },

    selectedItems() {
      return this.filteredItems.filter((i) =>
        this.isSelectedItem(i[this.getSqlKey('id')])
      );
    },

    tableName() {
      return this.database.name;
    },
    itemsAsObjects() {
      let translations = {};
      this.dataSchema.forEach((e) => (translations[e.name] = e.label));
      return translations;
    },
    databaseLinkedViewRefactoredData() {
      const linkedViewData = {
        selectedDatabaseID: this.element?.settings?.connectedDatabase
          ?.selectedDatabaseID
          ? this.element.settings.connectedDatabase.selectedDatabaseID
          : this.element.selectedDatabaseID,
        currentTableFieldKey: this.element?.databaseLink?.currentTableFieldKey
          ? this.element.databaseLink.currentTableFieldKey
          : this.element.linkedKey,
        currentTableFieldCaption: this.element?.databaseLink
          ?.currentTableFieldCaption
          ? this.element.databaseLink.currentTableFieldCaption
          : this.element.linkedKeyCaption,
      };
      return linkedViewData;
    },
    databaseLinkedViewSelectedColumns() {
      return (
        this.element?.settings?.connectedDatabase?.selectedDatabaseColumn || []
      );
    },
    databaseLinkedViewFetchColumns() {
      const linkedKey = this.databaseLinkedViewRefactoredData.currentTableFieldKey;
      const columns = [...this.databaseLinkedViewSelectedColumns];

      if (linkedKey && !columns.includes(linkedKey)) {
        columns.push(linkedKey);
      }

      return columns;
    },
    databaseLinkedViewFetchKey() {
      return JSON.stringify([
        this.databaseLinkedViewRefactoredData.selectedDatabaseID || '',
        this.databaseLinkedViewRefactoredData.currentTableFieldKey || '',
        this.databaseLinkedViewFetchColumns.join('|'),
      ]);
    },
    showLinkedTable() {
      return (
        this.isDatabaseLinkedViewinAdd &&
        this.filteredItems.length &&
        !this.tableSkeletonLoader
      );
    },
    deleteConfirmationRecords() {
      const databseSchema = jsonParser(this.database.schema) || [];
      const showCaseFieldElement = databseSchema.find(
        (schema) => schema?.settings?.showcaseField
      );
      if (!this.confirmationModal.isMultipleItems && this.itemToDelete)
        return [
          {
            id: this.itemToDelete.id,
            name: showCaseFieldElement?.name
              ? this.itemToDelete[showCaseFieldElement.name]
              : this.itemToDelete.id,
          },
        ];
      const filterRecords = this.selectedItems.map((item) => ({
        id: item.id,
        name: showCaseFieldElement?.name
          ? item[showCaseFieldElement.name]
          : item.id,
      }));
      return filterRecords;
    },
  },
  async created() {
    try {
      this.tableSkeletonLoader = true;

      await this.getDatabaseLinkedViewData();
      let findLinkedViewDatabase = this.databaseList.find((linked) => {
        return (
          linked.name ===
          this.databaseLinkedViewRefactoredData.selectedDatabaseID
        );
      });
      this.database = findLinkedViewDatabase;
      this.tableSkeletonLoader = false;
    } catch (e) {
      console.log('error :>> ', e);
      this.tableSkeletonLoader = false;
      this.showToaster(
        "Bei der Verknüpfung mit der Datenbank vom Element 'Abrechnungsdaten' ist ein Fehler aufgetreten. Bitte stellen Sie sicher, dass die korrekte Datenbank ausgewählt wurde und Sie über die erforderlichen Zugriffsrechte verfügen.",
        'Fehlerhaft !',
        'danger'
      );
    }
  },
  watch: {
    async getsidebarLinkedCustomDBSettings(newValue, oldValue) {
      if (newValue && newValue.hasOwnProperty('updateItems')) {
        this.$store.dispatch('addSidebarLinkedCustomDBSettings', null);
        if (newValue.updateItems) {
          await this.getDatabaseLinkedViewData();
        }
        const customTableRef =
          this.$refs.customDatabaseListRef.$refs.customTableRef;
        if (customTableRef) customTableRef.onTrMouseOut(oldValue?.index || 0);
      }
    },
    async databaseLinkedViewFetchKey() {
      await this.getDatabaseLinkedViewData();
    },
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          var dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasnt a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind: function (el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
  components: {
    CustomDatabaseListView,
    ModalShare,
    TableSkeleton,
    htmlViewer,
    removeConfirmationModal,
  },
};
</script>
<style scoped>
*,
::before,
::after {
  box-sizing: border-box !important;
}

.codelos-custom-list .modal-window {
  position: absolute;
  z-index: 16;
}

.codelos-custom-list ul li {
  line-height: 17px;
}

.codelos-custom-list li {
  display: item;
  text-align: -webkit-match-parent;
}

.codelos-custom-list input:focus {
  outline-width: 0;
}

.codelos-custom-list input[type='checkbox'],
input[type='radio'] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  outline: 0;
  margin: 0 0 9px;
  font-size: 100%;
  vertical-align: middle;
  display: inline-block;
}

.codelos-custom-list .group-actions {
  display: block;
  background: #fff;
  position: fixed;
  bottom: 0;
  box-shadow: 0 -1px 0 rgba(76, 86, 103, 0.2),
    0 -2px 35px rgba(31, 37, 50, 0.14);
  z-index: 11;
  left: 0;
  width: 100%;
  height: 76px;
  padding: 10px 35px;
  transition: transform 0.3s ease, -webkit-transform 0.3s ease;
  text-align: center;
  float: left;
  clear: both;
}

.codelos-custom-list .group-actions .inner {
  width: 100%;
  text-align: left;
  display: block;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  line-height: 22px;
}

.codelos-custom-list .selected-items {
  font-size: 11px;
  border-radius: 100px;
  background: #0fbf00;
  color: #fff;
  padding: 1px 14px 0px;
  margin: 1px 6px 0 0;
  float: left;
  font-weight: 600;
}
.codelos-custom-list .selected-items-label {
  float: left;
  font-size: 12px;
  color: #4a556b;
  font-weight: 600;
  text-transform: uppercase;
  float: left;
  margin: 2px 0 0 10px;
  text-rendering: optimizelegibility;
}

.codelos-custom-list .group-actions .toolbar {
  margin: 3.8px 0 0 -179px;
  position: absolute;
  left: 50%;
}
.codelos-custom-list .toolbar .item {
  float: left;
  margin: 0 15px;
  list-style: none;
  padding: 0;
  display: item;
  text-align: -webkit-match-parent;
}
.codelos-custom-list .toolbar .item .link {
  cursor: pointer;
  top: 50%;
  display: block;
  text-indent: -9999px;
  opacity: 0.9;
  background-size: 882px 840px;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  display: block;
  overflow: hidden;
}

.codelos-custom-list .toolbar .share .link {
  background-image: url(../../assets/img/project-sprite.png);
  background-position: 0 -759px;
}

.codelos-custom-list .toolbar .delete .link {
  background-image: url(../../assets/img/project-sprite.png);
  background-position: -868px 0;
  width: 14px;
  height: 18px;
}

.codelos-custom-list .toolbar .download .link {
  background-image: url(../../assets/img/project-sprite.png);
  background-position: -800px 0;
  width: 18px;
  height: 18px;
}
.codelos-custom-list .toolbar .more {
  padding-top: 8px;
  padding-bottom: 8px;
  cursor: pointer;
}

.codelos-custom-list .toolbar .more .link {
  background-image: url(../../assets/img/project-sprite.png);
  background-position: -463px -759px;
  width: 18px;
  height: 4px;
}

.codelos-custom-list .toolbar .more .toggle-list-wrapper.toggle-up .item {
  background: #fff;
  line-height: 36px;
  width: 100%;
  margin: 0;
  padding: 0 19px;
  margin-left: 7px;
  font-size: 14px;
}

.codelos-custom-list .toolbar .more .toggle-list-wrapper.toggle-up .item.more {
  width: 30px;
  background-size: 368px 13px;
  background-repeat: no-repeat;
  background-position: 18px -2px;
}

.codelos-custom-list .toolbar .more .toggle-list-wrapper.toggle-up {
  margin-top: -100%;
  padding: 25px 0px 25px 0px;
  min-width: 195px;
  left: 0;
  top: 0;
}

.codelos-custom-list .toolbar .more .toggle-list-wrapper.toggle-up .item:hover {
  background-color: #f0f0f0;
}

.codelos-custom-list .select-all-wrapper {
  float: right;
  margin-right: 100px;
  margin-top: -11px;
}
.codelos-custom-list .btn-select-all {
  background-color: white;
  border-style: none;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  margin: 12.5px;
}
.codelos-custom-list .btn-select-all:focus {
  outline: none;
}

.codelos-custom-list ::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
.codelos-custom-list ::v-deep .toast:not(.show) {
  display: block;
}

.codelos-custom-list ::v-deep .custom-table > thead {
  background: #fff;
}
.codelos-custom-list ::v-deep .custom-table thead tr:after {
  content: none;
}
.codelos-custom-list ::v-deep .custom-table .hoveritem,
.codelos-custom-list .custom-table .hoveritem:not(:last-child):hover {
  color: #9090a2 !important;
  font-size: 14px;
  line-height: 36px;
}

.codelos-custom-list ::v-deep .custom-table tr td {
  border-top: 1px solid rgb(14 15 12 / 12%) !important;
}
.codelos-custom-list ::v-deep .custom-table tr:hover td {
  border-top: 1px solid transparent !important;
}
.codelos-custom-list ::v-deep .custom-table {
  border-spacing: 0 4px;
}

.codelos-custom-list ::v-deep .custom-table td {
  color: #333343;
  font-size: 14px;
  line-height: 36px;
  font-weight: 400;
  padding: 7px 15px 6px;
}
.codelos-custom-list .custom-database-list {
  height: calc(100% - 60px);
}

.codelos-custom-list .custom-database-list .codelos-custom-list {
  height: 100%;
}

.codelos-custom-list .custom-database-list .codelos-custom-list .h-100 {
  height: 100%;
}

.codelos-custom-list .custom-database-list .codelos-custom-list .listwrapper {
  height: calc(100% - (78px + 130px + 20px));
  overflow: auto;
}
.codelos-custom-list .custom-database-list .custom-table-wrap {
  /* max-height: unset !important; */
}

.codelos-custom-list .custom-table tbody tr:hover,
.codelos-custom-list .custom-table tbody tr.isrowchecked {
  box-shadow: none;
  top: unset;
}

.codelos-custom-list .filter ::v-deep .dropdown-item {
  color: #58647d;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  border-radius: 3px;
  padding: 5px 10px;
  white-space: normal;
  width: auto !important;
}

/* New UI */

.codelos-custom-list .text-filter input,
.codelos-custom-list .datetime-filter input {
  border-radius: 6px;
  border: 1px solid #cdcdcd;
  margin: 0;
  height: 35px !important;
  margin-left: 24px;
  min-width: 135px;
  font-size: 13px;
  color: #58647d;
  text-align: left;
}

.codelos-custom-list ::v-deep .dropdown-menu {
  min-width: unset !important;
  padding: 0px !important;
}

.tooltip.b-tooltip {
  top: 9% !important;
}
</style>
